var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveVirtualEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,10.5h7c0.3,0,0.5-0.1,0.7-0.3S18,9.8,18,9.5S17.9,9,17.7,8.8c-0.2-0.2-0.4-0.3-0.7-0.3h-7c-0.3,0-0.5,0.1-0.7,0.3 C9.1,9,9,9.2,9,9.5s0.1,0.5,0.3,0.7C9.5,10.4,9.7,10.5,10,10.5z M10,14.5h7c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7 s-0.4-0.3-0.7-0.3h-7c-0.3,0-0.5,0.1-0.7,0.3C9.1,13,9,13.2,9,13.5s0.1,0.5,0.3,0.7C9.5,14.4,9.7,14.5,10,14.5z M7,10.5 c0.3,0,0.5-0.1,0.7-0.3S8,9.8,8,9.5S7.9,9,7.7,8.8C7.5,8.6,7.3,8.5,7,8.5S6.5,8.6,6.3,8.8C6.1,9,6,9.2,6,9.5s0.1,0.5,0.3,0.7 S6.7,10.5,7,10.5z M7,14.5c0.3,0,0.5-0.1,0.7-0.3S8,13.8,8,13.5S7.9,13,7.7,12.8S7.3,12.5,7,12.5s-0.5,0.1-0.7,0.3S6,13.2,6,13.5 s0.1,0.5,0.3,0.7S6.7,14.5,7,14.5z M9,21.5c-0.3,0-0.5-0.1-0.7-0.3C8.1,21,8,20.8,8,20.5v-1H4c-0.5,0-1-0.2-1.4-0.6 C2.2,18.5,2,18,2,17.5v-12c0-0.6,0.2-1,0.6-1.4S3.5,3.5,4,3.5h16c0.5,0,1,0.2,1.4,0.6C21.8,4.5,22,5,22,5.5v12c0,0.5-0.2,1-0.6,1.4 c-0.4,0.4-0.9,0.6-1.4,0.6h-4v1c0,0.3-0.1,0.5-0.3,0.7s-0.4,0.3-0.7,0.3H9z M4,17.5h16v-12H4V17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveVirtualEvent);
export default __webpack_public_path__ + "static/media/LiveVirtualEvent.96b0551d7aadb331dd0569a34a1df1c9.svg";
export { ForwardRef as ReactComponent };